import parallax from './parallax'
import reveal from './reveal'
import { createScrollHub } from './ScrollHub'

const addPerformanceStyles = () => {
  const style = document.createElement('style')
  style.innerHTML = '[data-scroll-id] { backface-visibility: hidden }'
  document.head.appendChild(style)
}

export default {
  install(app, options = {}) {
    addPerformanceStyles()

    const ScrollHub = createScrollHub()

    const modules = {
      parallax: parallax(ScrollHub),
      reveal: reveal(ScrollHub),
    }

    if (options) {
      Object.values(modules).forEach(({ setOptions }) => (setOptions ? setOptions(options) : null))
    }
    if (options.scrollingElement) {
      ScrollHub.init(options.scrollingElement, options.scrollEventTarget)
    }

    app.directive('scroll', {
      mounted(node, { arg, value, modifiers }) {
        const uid = node.dataset.scrollId || crypto.randomUUID()
        node.dataset.scrollId = uid
        if (!modules[arg] || !modules[arg].add) return
        modules[arg].add({ uid, node, value, modifiers })
      },
      unmounted(node, { arg }) {
        if (!modules[arg] || !modules[arg].remove) return
        modules[arg].remove(node.dataset.scrollId)
      },
    })

    app.config.globalProperties.$scrollHub = {
      setScrollingElement: ScrollHub.init,
      triggerUpdate: ScrollHub.triggerUpdate,
      unbind: ScrollHub.unbind,
      bind(handler) {
        const uid = crypto.randomUUID()
        ScrollHub.bind(uid, handler)
        return uid
      },
    }
  },
}
